(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userContactInfoTypeAdd', ['ContactInfo', 'ContactInfoService', 'Alert', 'UserContactInfoTypeEnum', UserContactinfoTypeAddFn]);

    /* directive for add-dropdown contact info type */
    function UserContactinfoTypeAddFn(ContactInfo, ContactInfoService, Alert, UserContactInfoTypeEnum) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-contact-info-type-add.template.html',
            scope: {
                contactinfos: '='
            },
            replace: true
        };
        return directive;


        // link
        function link(scope) {
            // set info-types
            scope.types = ContactInfoService.data.contactinfotypes;


            /* add new contact info type */
            scope.addNewContactInfo = function (type) {
                // new contact info object
                var info = new ContactInfo();
                info.init(type);
                // set sort order
                info.sortOrder = scope.contactinfos.length;
                // set showincontactdetail default true
                info.showInContactDetails = true

                // check if its an email and if there already is one
                if (info.fK_UserContactInfoType === UserContactInfoTypeEnum.Email.value) {
                    for (let i = 0; i < scope.contactinfos.length; i++) {
                        if (scope.contactinfos[i].fK_UserContactInfoType === UserContactInfoTypeEnum.Email.value) {
                            Alert.error('single_email_allowed');
                            return;
                        }
                    }
                }
                
                // add to array
                scope.contactinfos.push(info);
            };

        }
    }

})();